import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  updatedDate: string;
  children: ReactNode;
}

/**
 * Shared chrome for /privacy and /terms — back link, title strip, readable body.
 */
export function LegalPage({ title, updatedDate, children }: Props) {
  return (
    <div className="lume-bg min-h-svh">
      <div className="h-0.5 bg-gradient-to-r from-accent to-accent-dim" />

      <div className="max-w-2xl mx-auto px-6 pb-16" style={{ paddingTop: 'max(3.5rem, env(safe-area-inset-top))' }}>
        <Link to="/" className="text-caption text-text-tertiary hover:text-accent">
          ← Back to Lumé
        </Link>

        <h1 className="text-headline text-text mt-6">{title}</h1>
        <p className="text-caption text-text-tertiary mt-1.5">Last updated: {updatedDate}</p>

        <div className="legal-body mt-8">{children}</div>
      </div>

      <style>{`
        .legal-body {
          color: #A69E8C;
          font-size: 15px;
          line-height: 1.6;
        }
        .legal-body h2 {
          color: #F5F0E8;
          font-size: 18px;
          font-weight: 600;
          margin-top: 32px;
          margin-bottom: 12px;
        }
        .legal-body h3 {
          color: #F5F0E8;
          font-size: 15px;
          font-weight: 600;
          margin-top: 20px;
          margin-bottom: 8px;
        }
        .legal-body p { margin-bottom: 14px; }
        .legal-body ul {
          list-style: disc;
          padding-left: 22px;
          margin-bottom: 14px;
        }
        .legal-body ul li { margin-bottom: 6px; }
        .legal-body strong { color: #F5F0E8; }
        .legal-body a {
          color: #D4A84E;
          text-decoration: underline;
          text-decoration-thickness: 1px;
          text-underline-offset: 2px;
        }
      `}</style>
    </div>
  );
}
